import { createIntl, createIntlCache, type PrimitiveType } from "react-intl";

import { englishMessages, type MessageId } from "@/i18n/catalogs/en";
import type { MessageCatalog, SupportedLocale } from "@/i18n/locales";

const cache = createIntlCache();
let runtimeIntl = createIntl({ locale: "en", messages: englishMessages }, cache);

export function setRuntimeCatalog(
  locale: SupportedLocale,
  messages: MessageCatalog
): void {
  runtimeIntl = createIntl({ locale, messages }, cache);
}

export function translateMessage(
  id: MessageId,
  values?: Record<string, PrimitiveType>
): string {
  const message = runtimeIntl.formatMessage(
    { id, defaultMessage: englishMessages[id] },
    values
  );
  // Extracted JSX fragments may border interpolated nodes. HTML collapses these
  // spaces while preserving the original word boundary.
  return /^[^.]+\.[A-Z]/.test(id) ? ` ${message} ` : message;
}

export function translateError(
  code: string | undefined,
  fallback: string,
  params?: Record<string, PrimitiveType>
): string {
  const id = `errors.${code ?? "request_failed"}`;
  if (!(id in englishMessages)) return fallback;
  return translateMessage(id as MessageId, params);
}
